import { NavLink } from 'react-router-dom';
import { useAdmin } from '../AdminContext';

/**
 * Het aanbod hoort bij elkaar: behandelingen, protocollen en de huidthema's die ze koppelen.
 * Eén rij tabs bovenaan alle drie, zodat Sarah er zonder het menu tussen wisselt (BEHEER-PLAN §11,
 * fase 3). De adressen blijven gewoon zoals ze waren.
 */
const tabs = [{
  to: '/be/behandelingen',
  label: 'Behandelingen'
}, {
  to: '/be/protocollen',
  label: 'Protocollen'
}, {
  to: '/be/huidvragen',
  label: 'Huidthema’s & koppelingen'
}] as const;
export function OfferTabs() {
  const {
    issues
  } = useAdmin();
  return <nav aria-label="Aanbod" className="-mx-4 mb-6 overflow-x-auto px-4 sm:mx-0 sm:px-0 [scrollbar-width:none]" data-id="element-660" data-mp="250cvkj2kta3l">
      <ul className="flex min-w-max gap-6 border-b border-line" data-id="element-661" data-mp="29yebww8mavbd">
        {tabs.map(t => <li key={t.to} data-id="element-662" data-mp="3882335fi4qr">
            <NavLink to={t.to} end className={({
          isActive
        }) => `relative inline-flex min-h-11 items-center gap-2 whitespace-nowrap pb-3 pt-2 text-[14px] transition-colors duration-150 ease-soft sm:min-h-0 sm:pt-1 ${isActive ? 'text-ink after:absolute after:inset-x-0 after:-bottom-px after:h-0.5 after:bg-ink' : 'text-muted hover:text-ink'}`} data-id="element-663" data-mp="3a1c8sf9373i">
              {t.label}
              {t.to === '/be/huidvragen' && issues.length > 0 && <span className="min-w-[1.25rem] rounded-full bg-clay px-1.5 text-center text-[11px] leading-5 tabular-nums text-shell" data-id="element-664" data-mp="60uwgz7qka0t">
                  {issues.length}
                  <span className="sr-only" data-id="element-665" data-mp="14e4tv1bvdiz"> {issues.length === 1 ? 'koppeling klopt niet' : 'koppelingen kloppen niet'}</span>
                </span>}
            </NavLink>
          </li>)}
      </ul>
    </nav>;
}